





























































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {PModuleType} from '@/enums/configs';
import {PModuleWithMeasurements} from './../../system/modules/interfaces';
import {
  pmoduleDataRoutesByTypeMap,
  pmoduleDeveloperInfoDataRoutesByTypeMap,
  pmoduleStoresByTypeMap,
  pmoduleProblemLogDataRoutesByTypeMap,
} from '@v/system/modules/configurate';
import enumsModule from '@/store/modules/enumsModule';
import {httpClient} from '@/api/baseApi';
import MeasurementDialog from '@/components/MeasurementDialog.vue';
import {isNumber, isString} from '@/utils/commonUtils';
import axios from 'axios';
import {PMProcessActionType, PMProcessStatus} from './../../system/modules/enums';

@Component({
  components: {
    MeasurementDialog,
  },
})
export default class PModuleButtons extends Vue {
  @Prop()
  pmodule!: PModuleWithMeasurements | null;

  @Prop({required: false, default: true})
  showEditButton!: boolean;

  @Prop({required: false, default: true})
  showAdminButton!: boolean;

  @Prop({required: false, default: true})
  showViewButton!: boolean;

  @Prop({required: false, default: true})
  showHardwareNodeButtons!: boolean;

  itemPageRouteName = 'SystemModule';

  pmoduleTypes: any[] = [];

  moduleInfo: any = null;

  async created() {
    this.getModuleTypes();
    this.getModuleInfo();
  }

  async getModuleTypes() {
    const {data} = await httpClient.get<[]>(`module_types/`);
    this.pmoduleTypes = data;
  }

  isModuleActive = false;

  async getModuleInfo() {
    if (!this.pmodule) return;
    const {data} = await httpClient.get(`modules/`, {
      params: {
        guids: JSON.stringify([this.pmodule?.guid]),
      },
    });
    this.moduleInfo = data[0];
    if (this.moduleInfo)
      this.isModuleActive = this.moduleInfo.process_status == PMProcessStatus.Active;
  }

  isFictionModule() {
    if (!this.pmodule) return;
    return [
      PModuleType.MonitorStatesTasks,
      PModuleType.MonitorBoundaryTasks,
      PModuleType.MonitorChildTasks,
      PModuleType.BearingTasks,
      PModuleType.SignalTrendTasks,
    ].includes(this.pmodule.type);
  }

  isModuleHasView() {
    if (!this.pmodule) return;
    return pmoduleDataRoutesByTypeMap.has(this.pmodule.type);
  }

  async showModuleView() {
    if (!this.pmodule) return;
    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(this.pmodule.type),
      params: {id: `${this.pmodule.id}`},
    });
    window.open(href, '_blank');
  }

  isModuleExecutable() {
    if (!this.pmodule) return;
    return [
      PModuleType.CrmModule,
      PModuleType.DtcpServerModule,
      PModuleType.HeaterMonitorModule,
      PModuleType.CleanStorageModule,
      PModuleType.ServerMonitorModule,
      PModuleType.BearingControlModule,
      PModuleType.PingerModule,
    ].includes(this.pmodule.type);
  }

  async restart() {
    if (!this.pmodule) return;
    const module = pmoduleStoresByTypeMap.get(this.pmodule.type) as any;
    if (!module) return;
    await module
      .processAction({
        id: this.pmodule.id,
        action: PMProcessActionType.Restart,
      })
      .then(() => {
        this.isModuleActive = true;
      });
  }

  async stop() {
    if (!this.pmodule) return;
    const module = pmoduleStoresByTypeMap.get(this.pmodule.type) as any;
    if (!module) return;
    await module
      .processAction({
        id: this.pmodule.id,
        action: PMProcessActionType.Stop,
      })
      .then(() => {
        this.isModuleActive = false;
      });
  }

  async start() {
    if (!this.pmodule) return;
    const module = pmoduleStoresByTypeMap.get(this.pmodule.type) as any;
    if (!module) return;
    await module
      .processAction({
        id: this.pmodule.id,
        action: PMProcessActionType.Start,
      })
      .then(() => {
        this.isModuleActive = true;
      });
  }

  openNode() {
    if (!this.pmodule) return;
    const {href} = this.$router.resolve({
      name: 'node',
      params: {id: `${this.pmodule.nodes ? this.pmodule.nodes[0].node_id : null}`}, //TODO: fix it?
    });
    window.open(href, '_blank');
  }

  openHardware() {
    if (!this.pmodule) return;
    const {href} = this.$router.resolve({
      name: 'HardwareView',
      params: {hardwareId: `${this.moduleInfo.hw_pm}`},
    });
    window.open(href, '_blank');
  }

  isModuleHasDeveloperInfo() {
    if (!this.pmodule) return;
    return [
      PModuleType.DtcpTahoModule,
      PModuleType.CrmModule,
      PModuleType.DtcpServerModule,
      PModuleType.DtcpAccelerometerModule,
      PModuleType.DtcpTemperatureModule,
      PModuleType.DtcpEnergyModule,
      PModuleType.DtcpEmulatorModule,
      PModuleType.HeaterMonitorModule,
      PModuleType.CleanStorageModule,
      PModuleType.ServerMonitorModule,
      PModuleType.BearingControlModule,
      PModuleType.PingerModule,
    ].includes(this.pmodule.type);
  }

  async showDeveloperModuleInfo() {
    if (!this.pmodule) return;
    const {href} = this.$router.resolve({
      name: pmoduleDeveloperInfoDataRoutesByTypeMap.get(this.pmodule.type),
      params: {id: `${this.pmodule.id}`},
    });
    window.open(href, '_blank');
  }

  edit() {
    if (!this.pmodule) return;
    const currentModule = enumsModule.moduleTypes.filter(v => v.value === this.pmodule?.type);
    if (currentModule.length > 0) {
      if (this.isFictionModule()) {
        this.$router.push({
          name: `Edit${currentModule[0].value}`,
          params: {id: `${this.pmodule.id}`, type: currentModule[0].url},
        });
      } else {
        this.$router.push({
          name: `Edit${this.itemPageRouteName}`,
          params: {id: `${this.pmodule.id}`, type: currentModule[0].url},
        });
      }
    } else {
      this.$router.push({
        name: `Edit${this.itemPageRouteName}`,
        params: {id: `${this.pmodule.id}`},
      });
    }
  }

  showProblemLog() {
    if (!this.pmodule) return;
    const {href} = this.$router.resolve({
      name: pmoduleProblemLogDataRoutesByTypeMap.get(this.pmodule?.type),
      params: {id: `${this.pmodule?.id}`},
    });
    window.open(href, '_blank');
  }

  async changeBoundary() {
    if (!this.pmodule) return;
    // загружаем ПМ
    const mod = this.pmoduleTypes.filter((type: any) => type.value == this.pmodule?.type);
    const {data} = await httpClient.get(`${(mod as any)[0].url}/${this.pmodule.id}`);
    const selectedPmModule = data;
    const nameOfModule = selectedPmModule.name;

    const newMeasForm: any = [];

    // так как запрос вернул нам поля с другими названиями (с _ ), меняем названия полей на новые
    const measurement = selectedPmModule.measurements;
    if (measurement.length) {
      measurement.forEach((meas: any) => {
        const modal: any = {
          measurementId: meas.module_type_measurement_id,
          measurementDescription: meas.module_type_measurement_description,
          topWarningBoundary: meas.top_warning_boundary,
          topDangerBoundary: meas.top_danger_boundary,
          topErrorBoundary: meas.top_error_boundary,
          bottomWarningBoundary: meas.bottom_warning_boundary,
          bottomDangerBoundary: meas.bottom_danger_boundary,
          bottomErrorBoundary: meas.bottom_error_boundary,
        };
        newMeasForm.push(modal);
      });
    }
    selectedPmModule.type = this.pmodule.type;
    selectedPmModule.measurements = newMeasForm;

    const dialog = this.$refs.measurementDialog as any;
    const options = {
      saveCallback: async () => {
        dialog.$refs.form.reset();
        // TODO: переделать с получением data
        await this.saveMeasCallback(selectedPmModule, nameOfModule);
        dialog.close();
      },
    };
    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const request = {
      data: {
        bottomDangerBoundary: 0,
        bottomErrorBoundary: 0,
        bottomWarningBoundary: 0,
        editableBoundaries: {},
        isActive: false,
        isNew: false,
        measurementDescription: '',
        measurementId: 0,
        parent: {},
        topDangerBoundary: 0,
        topErrorBoundary: 0,
        topWarningBoundary: 0,
      },
    };

    dialog.openDialog(selectedPmModule, this.pmodule.type, options, source, request);
  }

  setNumberValue(value: any) {
    if (isString(value)) {
      const num = Number(value);
      if (isNumber(num)) return num;
    }
    return value;
  }

  async saveMeasCallback(selectedModule: any, nameOfModule: any) {
    try {
      selectedModule.measurements = selectedModule.measurements.filter(
        (x: any) => x.isActive === true,
      );
      selectedModule.measurements.forEach((meas: any) => {
        this.setNumberValue(meas.topWarningBoundary);
        this.setNumberValue(meas.topDangerBoundary);
        this.setNumberValue(meas.topErrorBoundary);
        this.setNumberValue(meas.bottomWarningBoundary);
        this.setNumberValue(meas.bottomDangerBoundary);
        this.setNumberValue(meas.bottomErrorBoundary);
      });
      if (!isString(selectedModule.id)) selectedModule.id = selectedModule.id.toString();
      selectedModule.name = nameOfModule;

      const store = pmoduleStoresByTypeMap.get(selectedModule.type) as any;
      if (!store) return;
      store.save(selectedModule);
      this.$emit('change');
    } catch {
      throw new Error('Ошибка сохранения');
    }
  }
}
